"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useErrorListener = () => {
    const listener = (event) => {
        /* eslint-disable no-console */
        console.warn(`Unhandled promise rejection: ${event.reason}`);
        event.preventDefault(); // Prevent console error from being logged
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('unhandledrejection', listener);
        return () => {
            window.removeEventListener('unhandledrejection', listener);
        };
    }, []);
};
exports.default = useErrorListener;
